import { z } from 'zod';

export const PROGRAM_CYCLES = ['ingenieur', 'licence', 'master'] as const;

export const LevelSchema = z.object({
  id: z.uuid(),
  programId: z.uuid(),
  yearIndex: z.number().int(),
  code: z.string(),
  label: z.string(),
});
export type Level = z.infer<typeof LevelSchema>;

export const ProgramSchema = z.object({
  id: z.uuid(),
  code: z.string(),
  name: z.string(),
  nameAr: z.string().nullable(),
  cycle: z.enum(PROGRAM_CYCLES),
  durationYears: z.number().int(),
  capacity: z.number().int(),
  levels: z.array(LevelSchema),
});
export type Program = z.infer<typeof ProgramSchema>;

export const ProgramInputSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^[A-Z]{2,4}$/, 'reference.errors.programCode'),
  name: z.string().trim().min(2).max(120),
  nameAr: z.string().trim().max(120).nullable().optional(),
  cycle: z.enum(PROGRAM_CYCLES),
  durationYears: z.number().int().min(1).max(6),
  capacity: z.number().int().min(0).max(10_000),
});
export type ProgramInput = z.infer<typeof ProgramInputSchema>;

export const GroupSchema = z.object({
  id: z.uuid(),
  levelId: z.uuid(),
  academicYearId: z.uuid(),
  name: z.string(),
  capacity: z.number().int(),
  /** Enrolled students in this group. */
  size: z.number().int(),
});
export type Group = z.infer<typeof GroupSchema>;

export const GroupQuerySchema = z.object({ yearId: z.uuid(), levelId: z.uuid().optional() });

export const GroupInputSchema = z.object({
  levelId: z.uuid(),
  academicYearId: z.uuid(),
  name: z
    .string()
    .trim()
    .regex(/^[A-Z0-9]{1,3}$/, 'reference.errors.groupName'),
  capacity: z.number().int().min(1).max(500),
});
export type GroupInput = z.infer<typeof GroupInputSchema>;
